export const firstLetterCapital = (name: string) =>
  name?.charAt(0).toUpperCase() + name.slice(1);
